// take in an object and turn any values into json.stringify
export default function jsonify(obj) {
   for(const k in obj) {
       if(obj[k] && typeof obj[k] == 'object') {
           obj[k] = JSON.stringify(obj[k])
       }
   }

   return obj
}